import { useEffect, useState } from 'react';
import { KNOWN_APP_KEYS } from '../../shared/appDetect';

/*
 * Client-Seite der Sandkasten-Erkennung fuer das Login-Add-In (Rafael, 29.09.2026,
 * v-cui-login-addin-sandkasten-20260929). Fragt NUR den eigenen CUI-Server nach
 * einer Portnummer; der Server fragt die App (server/lib/sandkasten-app.ts).
 * Fehler → null (kein Add-In), laut in der Konsole.
 */

type FetchLike = (url: string, init?: RequestInit) => Promise<Response>;

/** Laufende Anfragen je Port (nicht die Ergebnisse). */
const antworten = new Map<number, Promise<string | null>>();

/** Nur fuer Tests: Zwischenspeicher leeren. */
export function vergissSandkastenApps(): void { antworten.clear(); }

export function fragSandkastenApp(port: number, fetchImpl: FetchLike = (u, i) => fetch(u, i)): Promise<string | null> {
  const offen = antworten.get(port);
  if (offen) return offen;
  const p = fetchImpl(`/api/app-sandkasten/${port}`, { signal: AbortSignal.timeout(5000) })
    .then(async (r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const d = await r.json() as { appKey?: unknown };
      const appKey = typeof d?.appKey === 'string' && KNOWN_APP_KEYS.has(d.appKey) ? d.appKey : null;
      if (!appKey) console.warn(`[AppLogin] Sandkasten-Port ${port}: keine bekannte App — kein Login-Add-In`);
      return appKey;
    })
    .catch((e) => {
      console.warn(`[AppLogin] Sandkasten-Erkennung fuer Port ${port} fehlgeschlagen:`, e instanceof Error ? e.message : e);
      return null;
    })
    // Nur gleichzeitige Anfragen teilen sich eine Antwort. Den Zwischenspeicher je
    // Port fuehrt der Server (mit Ablaufzeit) — hier festgehalten bliebe ein
    // umgebauter Sandkasten bis zum Neuladen der CUI der alten App zugeordnet.
    .finally(() => { antworten.delete(port); });
  antworten.set(port, p);
  return p;
}

/** appKey der App hinter `port` (Sandkasten), oder null solange unbekannt/nicht erkannt. */
export function useSandkastenApp(port: number | null): string | null {
  const [treffer, setTreffer] = useState<{ port: number; appKey: string | null } | null>(null);
  useEffect(() => {
    if (port === null) return;
    let aktiv = true;
    void fragSandkastenApp(port).then((appKey) => { if (aktiv) setTreffer({ port, appKey }); });
    return () => { aktiv = false; };
  }, [port]);
  return port !== null && treffer?.port === port ? treffer.appKey : null;
}
